import axios from 'axios';
import StudyPlanCycleStudentOverviewPageActionTypes from './study-plan-cycle-student-overview-page-action-types';

export const loadStudyPlanCycleStudentOverviewPage = (payload) => async(dispatch, getState, { api }) => {
  const state = getState().studyPlanCycleStudentOverviewPage;
  state.studyPlanCycleStudentOverviewCancelToken?.cancel();
  state.studyPlanCycleStudentOverviewCancelToken = axios.CancelToken.source();
  dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.LOAD_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_PAGE_START });
  try {
    const { studyPlanId, studyPlanCycleId, studyPlanCycleStudentId } = payload;
    const studyPlanCycleStudent = await api.get(`api/study_plans/${studyPlanId}/cycles/${studyPlanCycleId}/students/${studyPlanCycleStudentId}`, state.studyPlanCycleStudentOverviewCancelToken.token);
    dispatch({
      type: StudyPlanCycleStudentOverviewPageActionTypes.LOAD_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_PAGE_END,
      payload: {
        studyPlanId,
        studyPlanCycleId,
        studyPlanCycleStudentId,
        studyPlanCycleStudent
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.LOAD_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_PAGE_END });
      throw error;
    }
  }
};

export const toggleStudyPlanCycleStudentOverviewAccreditmentForm = () => async(dispatch) => {
  dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.TOGGLE_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_ACCREDITMENT_FORM });
};

export const toggleStudyPlanCycleStudentOverviewConfirmDialog = (payload) => async(dispatch) => {
  dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.TOGGLE_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_CONFIRM_DIALOG, payload });
};

export const accreditStudyPlanCycleStudentOverview = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.ACCREDIT_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_START });
  const state = getState().studyPlanCycleStudentOverviewPage;
  state.studyPlanCycleStudentOverviewCancelToken?.cancel();
  state.studyPlanCycleStudentOverviewCancelToken = axios.CancelToken.source();
  const { studyPlanId, studyPlanCycleId, studyPlanCycleStudentId, studyPlanCycleStudent } = state;
  const apiModel = {
    ...studyPlanCycleStudent,
    accreditedCredits: payload?.accreditedCredits ?? state.accreditmentSize
  };
  try {
    await api.put(`api/study_plans/${studyPlanId}/cycles/${studyPlanCycleId}/students`, [ apiModel ]);
    if (studyPlanCycleStudent.credits + apiModel.accreditedCredits === studyPlanCycleStudent.cycleCredits && (studyPlanCycleStudent.dateTo ? new Date(studyPlanCycleStudent.dateTo) < new Date() : true)) {
      await api.post(`api/students/${studyPlanCycleStudent.studentId}/cycles/${studyPlanCycleStudentId}/actions/accredit`);
    }
    if (state.isAccreditmentFormVisible) {
      dispatch(toggleStudyPlanCycleStudentOverviewAccreditmentForm());
    }
    if (state.isConfirmationDialogVisible) {
      dispatch(toggleStudyPlanCycleStudentOverviewConfirmDialog());
    }
    dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.ACCREDIT_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_END });
    dispatch(loadStudyPlanCycleStudentOverviewPage({ studyPlanId, studyPlanCycleId, studyPlanCycleStudentId }));
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      throw error;
    }
    dispatch({ type: StudyPlanCycleStudentOverviewPageActionTypes.ACCREDIT_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_END });
  }
};